import * as React from 'react';
import { AppLocalizationKey } from '~/common/types/types';
import { FormattedMessage } from '~/components/common/common';
import * as styles from './description.module.scss';

type Props = {
  description: AppLocalizationKey;
};

const Description: React.FC<Props> = ({ description }) => (
  <div className={styles.wrapper}>
    <p className={styles.text}>
      <FormattedMessage message={description} />
    </p>
  </div>
);

export { Description };
